export default __webpack_public_path__ + "locales/pt-BR/InfoPanel.json?hash=3ad21a907e6f43bdf2cbfb7e95d2108f";